import { Breadcrumbs, Link as MuiLink, Typography, useTheme } from "@mui/material";
import SlashIcon from "@/assets/icons/slash-divider.svg?react";
import { Link } from "react-router-dom";
import { BreadcrumbProps } from "./types";
import { getStyles } from "./utils";

const Breadcrumb = ({ options }: BreadcrumbProps) => {
  const theme = useTheme();
  return (
    <Breadcrumbs separator={<SlashIcon />}>
      <MuiLink sx={getStyles(theme)} variant="body2" underline="none" component={Link} to="/">Home</MuiLink>
      {options.map((opt, index) => (opt.href ? (
        <MuiLink sx={getStyles(theme, options.length === ++index)} variant="body2" key={index} underline="none" component={Link} to={opt.href}>{opt.label}</MuiLink>
      ) : (
        <Typography sx={getStyles(theme, options.length === ++index)} variant="body2" key={index}>{opt.label}</Typography>
      )))}
    </Breadcrumbs>
  );
};

export default Breadcrumb;